import { createGraphQLRequest } from "../../../api/utils/httpRequest"
import type { Assignment } from "../../../graphql/types"
import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"

export const addAssignmentRequest = (headers: Record<string, any>, assignment: Assignment): Promise<any> =>
    createGraphQLRequest({
        headers: headers,
        body: {
            query: `
                 mutation assignmentAdd($assignment: AssignmentAddUpdateRequestData!) {
                    assignmentAdd(data: $assignment) {
                       success
                    }
                }
            `,
            operationName: "assignmentAdd",
            variables: {
                assignment: assignment,
            },
        },
    }).then(response => {
        if (response && response.data && response.data.assignmentAdd) {
            return response.data.assignmentAdd
        }

        return []
    })

export const updateAssignmentRequest = (headers: Record<string, any>, assignment: Assignment): Promise<any> =>
    createGraphQLRequest({
        headers: headers,
        body: {
            query: `
                 mutation assignmentUpdate($assignment: AssignmentAddUpdateRequestData!, $assignmentId: String!) {
                    assignmentUpdate(data: $assignment, assignmentId: $assignmentId) {
                      success
                    }
                }
            `,
            operationName: "assignmentUpdate",
            variables: {
                assignment: assignment,
                assignmentId: assignment.id,
            },
        },
    }).then(response => {
        if (response && response.data && response.data.assignmentUpdate) {
            return response.data.assignmentUpdate
        }

        return []
    })

export const deleteAssignmentRequest = (
    headers: Record<string, any>,
    id: string,
    locationId: Maybe<string>
): Promise<any> =>
    createGraphQLRequest({
        headers: headers,
        body: {
            query: `
             mutation assignmentDelete($assignmentId: String!, $locationId: String) {
                assignmentDelete(assignmentId: $assignmentId, locationId: $locationId) {
                  success
                }
            }
        `,
            operationName: "assignmentDelete",
            variables: {
                assignmentId: id,
                locationId: locationId,
            },
        },
    }).then(response => {
        if (response && response.data && response.data.assignmentDelete) {
            return response.data.assignmentDelete
        }

        return []
    })

export const fetchAssignments = (headers: Record<string, any>, locationId: Maybe<string>): Promise<Assignment[]> =>
    createGraphQLRequest({
        headers: headers,
        body: {
            query: `
                query assignments($locationId: String) {
                    assignments(locationId: $locationId) {
                        id
                        name
                        type
                        showAsQuickFilter
                        sortIndex
                        locationId
                        config {
                              customerRequired
                              guestCountRequired
                              deliveryAddressRequired
                              allowTableOpenOrders
                              receiptHighlight
                              multipleSessions
                              promptSeating
                              sendSmsOnOrderReady
                              orderReadyMessage
                           }
                        children {
                           id
                           name
                           type
                           showAsQuickFilter
                           parentId
                           locationId
                           sortIndex
                           config {
                              customerRequired
                              guestCountRequired
                              deliveryAddressRequired
                              allowTableOpenOrders
                              receiptHighlight
                              multipleSessions
                              promptSeating
                              sendSmsOnOrderReady
                              orderReadyMessage
                           }
                        }
                    }
                }
            `,
            operationName: "assignments",
            variables: {
                locationId: locationId,
            },
        },
    }).then(response => {
        if (response && response.data && response.data.assignments) {
            return response.data.assignments
        }

        return []
    })
